import Enum from '@/modules/core/app/helpers/Enum';

export class DocumentExtractionStatus extends Enum {
  static PROCESSING: string = 'processing';
  static COMPLETED: string = 'completed';
  static FAILED: string = 'failed';
  static STOPPED: string = 'stopped';
}
